import React from "react";
import { Modal, Button } from "react-bootstrap";

class AboutUsModal extends React.Component {
  render() {
    return (
      <Modal {...this.props}>
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title-lg">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"></i>
            </button>
            About Us
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We are the leading professional body for Accounting Technicians,
            with more than 10,000 members and students on the island of Ireland.
          </p>
          <br />
          <p>
            Founded in 1983, we provide nationally and internationally
            recognised accounting qualifications which open the door to a
            rewarding career as an Accounting Technician, as well as further
            study.
          </p>
          <br />
          <p>
            Our members are employed in industry, practice and the public
            sector, at all levels of finance, where they proudly carry the
            respected professional designation of MIATI.
          </p>
          <br />
          <b>
          We educate, train and represent our members, throughout their professional lives.
          </b>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-warning" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AboutUsModal;
